import { useEffect, useState } from "react";
import { isProductionOrigin } from "libs/productionOrigins";

const HUBSPOT_PORTAL_ID = "19591312";

const useHubspot = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      if (isProductionOrigin()) hubspotLoader(HUBSPOT_PORTAL_ID)();

      setIsLoaded(true);
    }
  }, [isLoaded, setIsLoaded]);
};

export default useHubspot;

const hubspotLoader = (portalId) => () => {
  if (document.getElementById("hs-script-loader")) return;

  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.id = "hs-script-loader";
  script.async = true;
  script.defer = true;
  script.src = `//js.hs-scripts.com/${portalId}.js`;
  head.appendChild(script);
};
